import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
VerifyDialog.defaultProps = {
    preventRedirect: false
};
/**
 * moaui Styled VerifyDialog
 *
 * @param props
 * @returns JSX.Element
 */
function VerifyDialog(props) {
    return (_jsx(StyledComponent, __assign({}, props)));
}
export default VerifyDialog;
